import Alpine from "alpinejs";

Alpine.data('notification', () => ({
    isOpen: false,
    uid: null,
    mode: 1,

    init(el, uid, mode) {
        this.uid = uid;
        this.mode = mode;

        // Check if notification was previously closed
        const closedNotifications = JSON.parse(sessionStorage.getItem('closedNotifications') || '[]');
        if (closedNotifications.includes(this.uid)) {
            return;
        }

        if (this.mode === 1) {
            // Mode 1: Show when scrolled into view
            const observer = new IntersectionObserver((entries) => {
                entries.forEach(entry => {
                    if (entry.isIntersecting) {
                        this.isOpen = true;
                        observer.disconnect();
                    }
                });
            });
            observer.observe(el);
        } else if (this.mode === 2) {
            // Mode 2: Show after 2 seconds
            setTimeout(() => {
                this.isOpen = true;
            }, 2000);
        }
    },

    close() {
        this.isOpen = false;

        // Store in session storage
        const closedNotifications = JSON.parse(sessionStorage.getItem('closedNotifications') || '[]');
        if (!closedNotifications.includes(this.uid)) {
            closedNotifications.push(this.uid);
            sessionStorage.setItem('closedNotifications', JSON.stringify(closedNotifications));
        }
    }
}));
